import Modal from "Components/Common/Modal";

import * as S from "./styles";

/**
 * Tabela por trás de um número do dashboard.
 *
 * O componente é GENÉRICO de propósito: título, colunas e rótulos vêm do backend
 * (`POST /projects/dashboard-details`), que já é o dono dos nomes dos KPIs. Aqui
 * só se decide a formatação por tipo de coluna — valor por extenso no modal, ao
 * contrário do cartão, que é abreviado ("R$ 1.2M").
 */
const formatValue = (value, type) => {
  if (value === null || value === undefined || value === "") return "—";

  if (type === "currency")
    return Number(value).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

  if (type === "number") return Number(value).toLocaleString("pt-BR");

  return value;
};

const KpiDetails = ({ details, onClose }) => {
  if (!details) return null;

  const { title, columns = [], rows = [] } = details;

  return (
    <Modal
      open
      title={title}
      allowDismiss
      showButtons
      showBackButton
      onDismiss={onClose}
    >
      {rows.length === 0 ? (
        <S.Empty>Nenhum item para exibir.</S.Empty>
      ) : (
        <S.TableWrapper>
          <S.Table>
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key} data-type={column.type}>
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  {columns.map((column) => (
                    <td key={column.key} data-type={column.type}>
                      {formatValue(row[column.key], column.type)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </S.Table>
        </S.TableWrapper>
      )}
    </Modal>
  );
};

export default KpiDetails;
